import { Box, useMediaQuery } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import ProductGroupingCreate from "pages/product_grouping/ProductGroupingCreate";
import ProductGroupingList from "pages/product_grouping/ProductGroupingList";
import React from "react";
import { MdDocumentScanner, MdOutlineAddModerator } from "react-icons/md";

const ProductGrouping = () => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod={smallScreen ? "Grouping" : "Product grouping"}
        viewIcon={<MdDocumentScanner />}
        createIcon={<MdOutlineAddModerator />}
        createChildren={<ProductGroupingCreate />}
        listChildren={<ProductGroupingList />}
      />
    </Box>
  );
};

export default ProductGrouping;
